import type { ComponentProps, JSX } from 'react';

import { IconArrowLeftButton } from './arrow-left-button';
import { IconArrowRightButton } from './arrow-right-button';
import { IconChevron } from './chevron';
import { IconChevronLeft } from './chevron-left';
import { IconChevronRight } from './chevron-right';
import { IconClose } from './close';
import { EIcons } from './EIcons';
import { IconLock } from './lock';
import { IconPlus } from './plus';
import { IconSearch } from './search';

const icons: Record<string, ({ ...props }) => JSX.Element> = {
  [EIcons.iconChevron]: IconChevron,
  [EIcons.iconChevronLeft]: IconChevronLeft,
  [EIcons.iconChevronRight]: IconChevronRight,
  [EIcons.iconClose]: IconClose,
  [EIcons.iconPlus]: IconPlus,
  [EIcons.iconArrowLeftButton]: IconArrowLeftButton,
  [EIcons.iconArrowRightButton]: IconArrowRightButton,
  [EIcons.iconLock]: IconLock,
  [EIcons.iconSearch]: IconSearch,
};

interface IconProps extends ComponentProps<'svg'> {
  icon: EIcons;
}

export const Icon = ({ icon, ...props }: IconProps) => {
  const IconComponent = icons?.[icon];

  if (!IconComponent) return null;

  return <IconComponent {...props} role="figure" aria-label={icon} />;
};
